import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TIMEZONE_DATA, TimeZoneData } from '../timezone-data';
@Component({
  selector: 'tenant-startdate',
  templateUrl: './tenant-startdate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe
]
})
export class TenantStartDateComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);
  keyName!: string ;
  value!:number;
  format!:string;

  // Use the complete timezone data from the local file
  private readonly TIMEZONES: TimeZoneData[] = TIMEZONE_DATA;
  

  getDate(date:any):Date{
    return new Date(date);
  }

  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false

  }

  hasValue(obj: any) {
    if (obj != null && obj != undefined)
      return true;
     else return false
  }

  getTenantStartDate(data: any): string {
    const date = data.tenant_start_date;
    const tenantTimezone = data?.timezone; // Get tenant timezone from response
    
    if (!date || !tenantTimezone) {
      return '-';
    }

    // Find the timezone info from TIMEZONE_DATA
    const timezoneInfo = this.TIMEZONES.find(tz => tz.Id === tenantTimezone);
    
    if (!timezoneInfo) {
      // Fallback to original date if timezone not found
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    }

    // Convert the date to the tenant's timezone
    const convertedDate = this.convertDatetimeToTimezone(new Date(date), timezoneInfo.BaseUtcOffset);
    
    // Format the date using MMM d, y, h:mm:ss a format
    return convertedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  }

  /**
   * Convert datetime to specific timezone using UTC offset
   * @param datetime - The date to convert
   * @param offsetString - UTC offset string like "+04:00" or "-05:00"
   * @returns Converted date
   */
  convertDatetimeToTimezone(datetime: Date, offsetString: string): Date {
    // Determine the sign (positive if no sign)
    let sign = 1;
    if (offsetString.startsWith('-')) {
      sign = -1;
      offsetString = offsetString.substring(1); // Remove the sign for parsing
    } else if (offsetString.startsWith('+')) {
      offsetString = offsetString.substring(1); // Remove the + sign for parsing
    }
  
    // Split the offset into hours, minutes, and seconds
    const [hoursStr, minutesStr, secondsStr] = offsetString.split(':');
  
    const hours = parseInt(hoursStr, 10) || 0;
    const minutes = parseInt(minutesStr, 10) || 0;
    const seconds = parseInt(secondsStr, 10) || 0;
  
    const totalOffsetMilliseconds = sign * ((hours * 3600 + minutes * 60 + seconds) * 1000);
  
    // Apply the timezone offset directly to the datetime (don't convert to UTC first)
    const targetTime = datetime.getTime() + totalOffsetMilliseconds;
    return new Date(targetTime);
  }

}